import { render, staticRenderFns } from "./HistorialPuesto.vue?vue&type=template&id=9099451e&"
import script from "./HistorialPuesto.vue?vue&type=script&lang=js&"
export * from "./HistorialPuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports